<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-6" v-if="showForm">
                <b-card>
                    <form id="anexo" class="ajax_off" @submit.prevent="anexar()">
                        <b-form-file id="file" multiple ref="files" v-model="file" :state="Boolean(file)"
                            placeholder="Clique para anexar um novo arquivo ou arraste-o e solte-o aqui..."
                            drop-placeholder="Arraste e solte um arquivo aqui...">
                            <template slot="file-name" slot-scope="{ names }">
                                <b-badge variant="dark">{{ names[0] }}</b-badge>
                                <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                                    + {{ names.length - 1 }} arquivo(s)
                                </b-badge>
                            </template>
                        </b-form-file>
                        <btn-loading variant="success" form="anexo" :loading="loading" :reset="reset" v-if="!!file"
                            size="sm" title="Clique no botão para anexar!"><i class="fas fa-upload"></i>
                            Anexar</btn-loading>
                    </form>
                </b-card>
            </div>
        </div>

        <div class="row" v-if="anexos.length > 0">
            <div class="col-md-12" v-for="(anexo, IndexAnexo) in anexos" :key="IndexAnexo">
                <div v-if="IndexAnexo <= anexosToShow">
                    <div class="mr-2 item-anexo mb-2" style="
                  background-color: #f0f0f0;
                  width: 100px;
                  height: 70px;
                  text-align: center;
                  line-height: 50px;
                  font-size: 20px;
                  text-transform: uppercase;
                  font-weight: bold;
                  position: relative;
                  float: left;
                  padding: 10px;
                ">
                        {{ anexo.arquivo_name.split(".").pop() }}
                    </div>
                    <div>
                        <strong>{{ anexo.arquivo_name }}</strong><br />
                        <small v-if="anexo.colaborador">
                            Adicionado por: <b>{{ anexo.colaborador.name }}</b> em:
                            {{ moment(anexo.created_at).format("DD/MM/YYYY HH:mm:ss") }} -
                        </small>

                        <div class="d-flex align-items-center">
                            <a href="#" class="mr-2" @click.prevent="preview(anexo)"
                                v-if="!!anexo.visualizar"><u>Visualizar</u></a>

                            -
                            <a class="mr-2" :href="`/api/download/${anexo.id}`" :download="anexo.arquivo_name"
                                target="_blank"><u>Download</u></a>
                            -
                            <a class="mr-2" href="#" data-toggle="modal" data-target="#confirmar-apagar-upload" data-text=""
                                :data-id="anexo.id" data-modal="confirmar-apagar-upload" :data-name="anexo.arquivo_name"
                                data-route="anexos" data-route-action="deleteIt" title="Deletar"
                                :data-link="`https://app.econsulte.com/tarefas/tarefa/${anexo.id}`"><u>Excluir</u></a>
                            <span v-if="selecionar">
                                <b-button class="mr-2" :variant="`${checkExist(anexo) ? 'light' : 'outline-primary'
                                    }`" :disabled="checkExist(anexo)" @click.prevent="selecionado(anexo)"><span
                                        v-if="!checkExist(anexo)">Adicionar</span><span v-else>Já está adicionado na
                                        tarefa.</span>
                                </b-button>
                            </span>
                            <span v-if="checklist">
                                <b-form-checkbox :id="`checkbox-${anexo.id}`" v-model="selecionados" :value="anexo.id">
                                    Selecionar
                                </b-form-checkbox>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="custom_anexos">
                <a href="#" class="show-comentario" @click.prevent="anexosToShow += 5" style="text-decoration: underline"
                    v-if="!!anexos && anexos.length - anexosToShow > 0">Mostrar mais anexos ({{
                        anexos.length - anexosToShow + " oculto(s)"
                    }})</a>
                <a href="#" class="show-comentario text-danger" @click.prevent="anexosToShow = 5"
                    style="text-decoration: underline" v-if="!!anexos && anexosToShow >= anexos.length + 6">Ocultar
                    anexos</a>
            </div>
            <eFilePreview v-if="visualizar.id != ''" :title="visualizar.name" :id="`preview-${visualizar.id}`"
                :file="visualizar.link" />
        </div>
    </div>
</template>

<script>
import BtnLoading from "./BtnLoading.vue";
import eFilePreview from "./eFilePreview.vue";

export default {
    components: { eFilePreview, BtnLoading },
    data() {
        return {
            selecionados: [],
            loading: false,
            reset: false,
            anexosToShow: 0,
            file: null,
            visualizar: {
                id: "",
                name: "",
                link: "",
            },
            anexos: [],
        };
    },
    props: {
        tarefa_id: "",
        parent_name: "",
        parent_id: "",
        showForm: Boolean,
        checklist: Boolean,
        cliente_documento: String,
        custom_anexos: Array,
        selecionar: Boolean,
        BlockThisAnexos: { type: Array, default: [] },
    },
    mounted() {
        if (this.custom_anexos) {
            let uploads = [];

            this.custom_anexos.forEach(function (item) {
                uploads = [...uploads, item.upload];
            });

            this.anexos = uploads;
            this.anexosToShow = 5;
        } else {
            this.getAnexos();
        }
    },
    methods: {
        async anexar() {
            this.loading = true;
            var formData = new FormData();

            for (let file of this.$refs.files.files) {
                formData.append("files[]", file);
            }

            formData.set("parent_name", this.parent_name);
            formData.set("parent_id", this.parent_id);

            if (this.cliente_documento)
                formData.set("cliente_documento", this.cliente_documento);

            const result = await this.$api.post("anexos", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            this.file = null;
            this.reset = true;
            this.loading = false;


            this.$emit("arquivoSelecionado", result.data.anexo);
            if (!this.checklist) this.$bvModal.hide("anexos");

            this.getAnexos();
        },
        checkExist(anexo) {
            if (this.checklist) return false;

            if (
                this.BlockThisAnexos.findIndex(
                    (item) => parseInt(item.upload_id) === anexo.id
                ) > -1
            )
                return true;

            return false;
        },
        async getAnexos() {
            let result;
            if (this.cliente_documento) {
                result = await this.$api.get(
                    `anexos/cliente/${this.cliente_documento}`
                );
            }else{
                result = await this.$api.get(`uploads/${this.parent_name}/${this.parent_id}`);
            }
            this.anexos = result.data;

            this.anexosToShow = this.anexos.length;
        },
        preview(anexo) {
            this.visualizar.id = "";
            this.visualizar.link = "";
            this.visualizar.name = anexo.arquivo_name;
            this.visualizar.id = anexo.id;
            this.visualizar.link = anexo.link;

            setTimeout(() => {
                this.$bvModal.show(`preview-${this.visualizar.id}`);
            }, 100);
        },
        selecionado(anexo) {
            this.$emit("arquivoSelecionado", anexo);
            this.$bvModal.hide("anexos");
        },
        getSelecionados() {
            this.$emit("setSelecionados", this.selecionados);
            this.$bvModal.hide("anexos");
        },
    },
};
</script>
